import {BestellungPreisUndMwstSatz} from './bestellung-preis-und-mwst-satz';
import {BestellungEntry} from './bestellung-entry';

export class Subbestellung {
  knd_nr: string;
  artikelstamm: string;
  summen: BestellungPreisUndMwstSatz[];
  positionen: BestellungEntry[];
}
